export default "/img/CF.956c4e722424fd2cb7c8df79adb75848.png";